import SrtUploadTrialPlaceholder from '@/shared/assets/images/srt-upload-trial.png';
import SrtUploadPlaceholder from '@/shared/assets/images/srt-upload.png';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';
import { BoosterType } from '@/shared/types/Billing';

import { LimitedFeatureContent, ModalContent } from '../types';
import { getBullets } from './bullets';
import { BULLETS_HEADER_TEXT, BUTTON_TEXTS } from './texts';

const BASE_CONTENT: ModalContent = {
  title: 'Unlock SRT upload feature',
  bulletsHeader: BULLETS_HEADER_TEXT.withCreatorPro,
  buttonText: BUTTON_TEXTS.toCreatorPro,
  features: getBullets([
    'translate100',
    'lipSync',
    'voiceCloneSettings',
    'voicePresets',
    'srtUploadDownload',
    'subtitles',
    'aiRewrite',
  ]),
  media: {
    src: SrtUploadPlaceholder,
    type: 'image',
  },
  mixpanelButtonClickEvent: MixpanelEvents.srtUpgradeChoosePlanModalClick,
  mixpanelOpeningEvent: MixpanelEvents.srtUpgradeModal,
  subtitle:
    'Upgrade to Creator Pro plan to effortlessly pair your video with existing subtitles for accurate dubbing results',
};

const TRIAL_PLAN_CONTENT = {
  ...BASE_CONTENT,
  title: 'Unlock SRT upload',
  buttonText: 'Upgrade to Creator Pro',
  content: {
    chip: {
      title: 'Replace hours of manual editing with one click',
      text: 'Download SRT → Send for corrections → Upload updated file',
    },
    learnMore: {
      title: 'Learn more',
      link: 'https://help.rask.ai/hc/srt-upload-in-existing-project',
      text: 'how to use SRT upload',
    },
    perfectFor: {
      title: 'Perfect for',
      text: 'teams who edit subtitles externally and want to sync updates fast.',
    },
    selectedPlan: 'Creator Pro',
    whatYouCanDo: {
      title: 'Update subtitles in seconds',
      bullets: [
        'Upload an edited SRT file',
        'Instantly refresh text, timing, and speaker info',
        'No manual copy-paste',
      ],
    },
  },
  features: [],
  media: {
    ...BASE_CONTENT.media,
    src: SrtUploadTrialPlaceholder,
  },
  subtitle: 'Upload corrected transcript in one click.',
};

const STARTER_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inTrial,
};

const CREATOR_PLAN_CONTENT = {
  ...TRIAL_PLAN_CONTENT,
  booster: BoosterType.SRT,
  buttonText: 'or Upgrade to Creator Pro',
};

export const SRT_UPLOAD_CONTENT: LimitedFeatureContent = {
  creator: CREATOR_PLAN_CONTENT,
  starter: STARTER_PLAN_CONTENT,
  trial: TRIAL_PLAN_CONTENT,
};
